import { render, staticRenderFns } from "./ActiveRegularPromotions.vue?vue&type=template&id=5fac9d75&"
import script from "./ActiveRegularPromotions.vue?vue&type=script&lang=js&"
export * from "./ActiveRegularPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports